import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface InsuranceSearchResult {
    _id: string;
    name: string;
    groupId: string;
    alreadyAdded: boolean;
    partstraderRequired: boolean;
    sourcePartsRequired: boolean;
}

interface InsuranceSearchResponse {
    insuranceCompanies: Array<InsuranceSearchResult>;
    relatedCompanies?: Array<InsuranceSearchResult>;
}

const searchInsurance = async (sessionId: string, searchTerm: string): Promise<InsuranceSearchResponse> => {
    const { data } = await axios.get(`${API_URL}/insurance/search`,
        {
            headers: {
                Authorization: sessionId
            },
            params: {
                searchTerm
            }
        }
    );
    return data;
};

const fetchRelatedCompanies = async (sessionId: string, groupId: string): Promise<InsuranceSearchResponse> => {
    const { data } = await axios.get(`${API_URL}/insurance/search`,
        {
            headers: {
                Authorization: sessionId
            },
            params: {
                groupId
            }
        }
    );
    return data;
};

export const useSearchInsurance = (searchTerm: string) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/insurance/search', searchTerm],
        queryFn: () => searchInsurance(sessionContext?.sessionId ?? '', searchTerm),
        enabled: !!sessionContext?.sessionId && searchTerm.length > 2,
    });
};

export const useRelatedInsurance = (groupId: string | undefined) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/insurance/search/related', groupId],
        queryFn: () => fetchRelatedCompanies(sessionContext?.sessionId ?? '', groupId!),
        enabled: !!sessionContext?.sessionId && !!groupId,
    });
};
